const Pointer = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.49038 3.49026L8.14902 19.7955L10.9259 16.3244L11.6857 16.9322L10.9259 16.3244C11.5976 15.4848 12.85 15.4154 13.6103 16.1757L17.9533 20.5187L20.5189 17.9532L16.1758 13.6102C15.4155 12.8499 15.4849 11.5975 16.3245 10.9258L19.7956 8.1489L3.49038 3.49026ZM1.47043 3.70053C1.08161 2.33965 2.33977 1.08148 3.70065 1.4703L20.7101 6.33015C22.119 6.7327 22.4857 8.55812 21.3415 9.47348L17.7449 12.3508L22.0716 16.6776C22.7762 17.3821 22.7762 18.5243 22.0716 19.2288L19.229 22.0715C18.5244 22.776 17.3822 22.776 16.6777 22.0715L12.3509 17.7447L9.4736 21.3414C8.55824 22.4856 6.73282 22.1189 6.33027 20.71L1.47043 3.70053Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Pointer;
